module.exports = __webpack_public_path__ + "media/dashboard/assets/images/copy-f0e956e865bb081d213f77f50324d815.svg";